module.exports = __webpack_public_path__ + "img/TimeOfUse.be07af25.png";